import React from 'react';
// tslint:disable-next-line no-any
const Fragment = (React as any).Fragment; // Known issue - https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20249

export default Fragment;
